import React, { useEffect } from 'react';

import { useAppDispatch } from '../../../redux/hooks';
import { fetchConnectorStatus } from '../../../redux/slices/DeviceHubSlice';
import { setPageTitle } from '../../../redux/slices/PageTitleSlice';
import EventDeviceHub from '../index';

import DashboardWidgets from './dashboard-widgets/DashboardWidgets';

import '../scss/device-hub-dashboard.scss';

/**
 * Device Hub Dashboard Component
 * Displays device hub dashboard with widgets, charts, and alerts
 * @returns {any} JSX element
 */
function DeviceHubDashboard() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageTitle({ title: 'Dashboard' }));
    dispatch(fetchConnectorStatus());
  }, [dispatch]);

  return (
    <div className="device-hub-dashboard-wrap">
      <DashboardWidgets />
      <EventDeviceHub hideAddButton disablePageTitle />
    </div>
  );
}

export default DeviceHubDashboard;
